const trimWhitespace = (value: string): string => {
  return value.replace(/[\n\t\\ \r]*$/, '');
};
export default trimWhitespace;
